<template>
  <span :class="animationClass">{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    value: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 1200
    },
    useComma: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      displayValue: '0',
      animationClass: ''
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.animate(oldVal || 0, newVal);
    }
  },
  mounted() {
    this.animate(0, this.value);
  },
  methods: {
    animate(start, end) {
      this.animationClass = 'animate-pulse';

      const startTime = Date.now();

      const animateFrame = () => {
        const currentTime = Date.now();
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / this.duration, 1);

        // easeOutCubic 이징 함수
        const easeProgress = 1 - Math.pow(1 - progress, 3);

        const currentValue = start + (end - start) * easeProgress;

        // 숫자 포맷팅
        if (this.useComma) {
          this.displayValue = Math.floor(currentValue).toLocaleString();
        } else {
          this.displayValue = Math.floor(currentValue).toString();
        }

        if (progress < 1) {
          requestAnimationFrame(animateFrame);
        } else {
          this.animationClass = '';
          this.displayValue = this.useComma
            ? Math.floor(end).toLocaleString()
            : Math.floor(end).toString();
        }
      };

      requestAnimationFrame(animateFrame);
    }
  }
};
</script>

<style scoped>
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.animate-pulse {
  animation: pulse 0.6s ease-in-out;
}
</style>
